<template>
	<cus-header>
		<div class="login-container flex" :class="{school:type === 'school'}" v-loading="loading">
			<div class="left flex-center">
				<img src="../../assets/login/left_image.png" alt="" />
			</div>
			<div class="right">
				<div class="flex-center">
					<div class="head flex-se">
						<div>{{type === 'school' ? '校级管理员注册' : '参赛团队注册(队长)'}}</div>
					</div>
					<!-- <div class="return-school" @click="backLogin" v-if="type === 'school'">返回登录</div> -->
				</div>
				<div v-if="type === 'school'">
					<div class="content" v-if="step == 1">
						<el-form :model="schoolForm" :rules="schoolRules" ref="schoolRuleForm" label-position="top"
							class="demo-ruleForm">
							<el-form-item label="" prop="name">
								<el-input placeholder="输入姓名" v-model="schoolForm.name">
									<template slot="prepend">
										<div class="col-center">
											<div class="emphasize">*</div>
											<div class="prepend-label">姓名</div>
										</div>
									</template>
								</el-input>
							</el-form-item>
							<!-- 	<el-form-item label="" prop="name">
								<el-input placeholder="输入学校标识码" v-model="schoolForm.name">
									<template slot="prepend">
										<div class="col-center">
											<div class="emphasize">*</div>
											<div class="prepend-label">学校标识码</div>
										</div>
									</template>
								</el-input>
							</el-form-item> -->
							<el-form-item label="" prop="school_id">
								<div class="prepend-selected col-center">
									<div class="col-center prepend-selected-left">
										<div class="emphasize">*</div>
										<div class="prepend-label">所属院校</div>
									</div>
									<el-select style="flex-grow: 1;" v-model="schoolForm.school_id" filterable remote
										reserve-keyword placeholder="输入查询所属院校" :remote-method="remoteMethod"
										:loading="universityLoading">
										<el-option v-for="item in universityOptions" :key="item.id" :label="item.name"
											:value="item.id">
										</el-option>
									</el-select>
								</div>
							</el-form-item>
							<!-- <el-form-item label="" prop="project_ids">
								<div class="prepend-selected col-center">
									<div class="col-center prepend-selected-left">
										<div class="emphasize">*</div>
										<div class="prepend-label">所属项目</div>
									</div>
									<el-select multiple collapse-tags style="flex-grow: 1;"
										v-model="schoolForm.project_ids" filterable remote reserve-keyword
										placeholder="输入查询所属项目" :remote-method="projectMethod" :loading="projectLoading">
										<el-option v-for="item in projectOptions" :key="item.id" :label="item.title"
											:value="item.id">
										</el-option>
									</el-select>
								</div>
							</el-form-item>
							<el-form-item label="" prop="department">
								<el-input placeholder="输入部门名称" v-model="schoolForm.department">
									<template slot="prepend">
										<div class="col-center">
											<div class="emphasize">*</div>
											<div class="prepend-label">部门名称</div>
										</div>
									</template>
								</el-input>
							</el-form-item> -->
							<el-form-item label="" prop="mobile">
								<el-input :maxlength="11" placeholder="请输入手机号" v-model="schoolForm.mobile">
									<template slot="prepend">
										<div class="col-center">
											<div class="emphasize">*</div>
											<div class="prepend-label">手机号</div>
										</div>
									</template>
								</el-input>
							</el-form-item>
							<el-form-item label="" prop="email">
								<el-input placeholder="请输入邮箱" v-model="schoolForm.email">
									<template slot="prepend">
										<div class="col-center">
											<div class="emphasize">*</div>
											<div class="prepend-label">邮箱</div>
										</div>
									</template>
								</el-input>
							</el-form-item>
						</el-form>
					</div>
					<div class="content" v-if="step == 2">
						<el-form :model="schoolForm" :rules="schoolRules" ref="schoolRuleForm2" label-position="top"
							class="demo-ruleForm">
							<!-- <el-form-item prop="verify_code">
								<div class="flex-cb">
									<div class="verify-code">
										<el-input placeholder="验证码"
											v-model.number="ruleForm.verify_code"></el-input>
									</div>
									<div style="padding-left: 1.25rem;flex-grow: 1;width: 0;">
										<el-button :disabled="isSend" style="width:100%;height: 3rem;" type="primary" plain
											@click="send">{{isSend ? time+'s后重新获取': '获取验证码'}}</el-button>
									</div>
								</div>
							</el-form-item> -->
							<!-- <el-form-item label="" prop="username">
								<el-input placeholder="请输入用户名" v-model="schoolForm.username">
									<template slot="prepend">
										<div class="col-center">
											<div class="emphasize">*</div>
											<div class="prepend-label">登录用户名</div>
										</div>
									</template>
								</el-input>
							</el-form-item> -->
							<el-form-item label="" prop="password">
								<el-input placeholder="请输入密码" v-model="schoolForm.password" show-password>
									<template slot="prepend">
										<div class="col-center">
											<div class="emphasize">*</div>
											<div class="prepend-label">密码</div>
										</div>
									</template>
								</el-input>
							</el-form-item>
							<el-form-item label="" prop="checkPass">
								<el-input placeholder="请再次输入密码" v-model="schoolForm.checkPass" show-password>
									<template slot="prepend">
										<div class="col-center">
											<div class="emphasize">*</div>
											<div class="prepend-label">确认密码</div>
										</div>
									</template>
								</el-input>
							</el-form-item>
							<!-- <el-form-item label="" prop="remark">
								<el-input placeholder="请输入备注" v-model="schoolForm.remark">
									<template slot="prepend">
										<div class="col-center">
											<div class="prepend-label">备注</div>
										</div>
									</template>
								</el-input>
							</el-form-item> -->
							<el-form-item label="" prop="files">
								<div class="flex wrap">
									<upload text="点击上传附件" @success="uploadSuccess" tips="上传部门盖章的学校管理员信息表"></upload>
									<!-- <div class="downloadFile" @click="handleTemplateDownload">申请表模板下载(上传盖部门公章的pdf文档)
									</div> -->
								</div>
							</el-form-item>
						</el-form>
					</div>
				</div>
				<div v-else>
					<div class="content" v-if="step == 1">
						<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top"
							class="demo-ruleForm">
							<el-form-item label="" prop="name">
								<el-input placeholder="请输入姓名" v-model="ruleForm.name">
									<template slot="prepend">
										<div class="col-center">
											<div class="emphasize">*</div>
											<div class="prepend-label">姓名</div>
										</div>
									</template>
								</el-input>
							</el-form-item>
							<el-form-item label="" prop="school_id">
								<div class="prepend-selected col-center">
									<div class="col-center prepend-selected-left">
										<div class="emphasize">*</div>
										<div class="prepend-label">所属院校</div>
									</div>
									<el-select style="flex-grow: 1;" v-model="ruleForm.school_id" filterable remote
										reserve-keyword placeholder="输入查询所属院校" :remote-method="remoteMethod"
										:loading="universityLoading">
										<el-option v-for="item in universityOptions" :key="item.id" :label="item.name"
											:value="item.id">
										</el-option>
									</el-select>
								</div>
							</el-form-item>
							<!-- 	<el-form-item label="身份证号" prop="id_card">
								<el-input maxlength="18" placeholder="请输入身份证号" v-model="ruleForm.id_card"></el-input>
							</el-form-item> -->
							<!-- 	<el-form-item label="" prop="level">
								<div class="prepend-selected col-center">
									<div class="col-center prepend-selected-left">
										<div class="emphasize">*</div>
										<div class="prepend-label">职称</div>
									</div>
									<el-select style="flex-grow: 1;" v-model="ruleForm.level" placeholder="请选择职称">
										<el-option :label="item.name" :value="item.id"
											v-for="(item,index) in commonData.level" :key="index"></el-option>
									</el-select>
								</div>

							</el-form-item> -->
							<el-form-item label="" prop="phone">
								<el-input :maxlength="11" placeholder="请输入手机号" v-model="ruleForm.phone">
									<template slot="prepend">
										<div class="col-center">
											<div class="emphasize">*</div>
											<div class="prepend-label">手机号</div>
										</div>
									</template>
								</el-input>
							</el-form-item>
							<el-form-item label="" prop="email">
								<el-input placeholder="请输入邮箱" v-model="ruleForm.email">
									<template slot="prepend">
										<div class="col-center">
											<div class="emphasize">*</div>
											<div class="prepend-label">邮箱</div>
										</div>
									</template>
								</el-input>
							</el-form-item>

						</el-form>
					</div>
					<div class="content" style="padding-top: 120px;" v-if="step == 2">
						<el-form :model="ruleForm" :rules="rules" ref="ruleForm2" label-position="top"
							class="demo-ruleForm">

							<!-- 	<el-form-item label="" prop="nickname">
								<el-input placeholder="请输入用户名" v-model="ruleForm.nickname">
									<template slot="prepend">
										<div class="col-center">
											<div class="emphasize">*</div>
											<div class="prepend-label">登录用户名</div>
										</div>
									</template>
								</el-input>
							</el-form-item> -->
							<!-- <el-form-item prop="verify_code">
								<div class="flex-cb">
									<div class="verify-code">
										<el-input placeholder="验证码"
											v-model.number="ruleForm.verify_code"></el-input>
									</div>
									<div style="padding-left: 1.25rem;flex-grow: 1;width: 0;">
										<el-button :disabled="isSend" style="width:100%;height: 3rem;" type="primary" plain
											@click="send">{{isSend ? time+'s后重新获取': '获取验证码'}}</el-button>
									</div>
								</div>
							</el-form-item> -->
							<el-form-item label="" prop="password">
								<el-input placeholder="请输入密码" v-model="ruleForm.password" show-password>
									<template slot="prepend">
										<div class="col-center">
											<div class="emphasize">*</div>
											<div class="prepend-label">密码</div>
										</div>
									</template>
								</el-input>
							</el-form-item>
							<el-form-item label="" prop="checkPass">
								<el-input placeholder="请再次输入密码" v-model="ruleForm.checkPass" show-password>
									<template slot="prepend">
										<div class="col-center">
											<div class="emphasize">*</div>
											<div class="prepend-label">确认密码</div>
										</div>
									</template>
								</el-input>
							</el-form-item>
						</el-form>
					</div>
				</div>

				<div class="floor row-center">
					<el-button color="#358BF6" @click="submitForm">{{step == 2 ? '立即注册' : '下一步'}}</el-button>
				</div>
				<div class="return-login" @click="backLogin">返回登录</div>
			</div>
		</div>
	</cus-header>
</template>

<script>
	import {
		register,
		sendCode,
		schoolRegister,
		queryProject
	} from '@/common/api/user.js'
	import {
		jobLevel
	} from '@/common/config.js'
	import {
		getUniversityList
	} from '@/common/api/public.js'
	import {
		validatePhone,
		validateIdCard,
		validateEmail
	} from '../../utils/reg.js'
	import upload from "../components/upload"
	export default {
		name: '',
		props: {

		},
		components: {
			upload
		},
		data() {
			let validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					if (this.ruleForm.checkPass !== '') {
						this.$refs.ruleForm2.validateField('checkPass');
					}
					callback();
				}
			};
			let validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.ruleForm.password) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			let schoolValidatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					if (this.schoolForm.checkPass !== '') {
						this.$refs.schoolRuleForm2.validateField('checkPass');
					}
					callback();
				}
			};
			let schoolValidatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.schoolForm.password) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			let validateFiles = (rule, value, callback) => {
				console.log(rule, value, this.schoolForm.files, 'rule,valuerule, value')
				if (this.schoolForm.files === '' || !this.schoolForm.files.length) {
					callback(new Error('请选择上传附件'));
				} else {
					callback();
				}
			};
			// let validateEmail = (rule, value, callback) => {
			// 	let reg = /^\w+((.\w+)|(-\w+))+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
			// 	if (value && !reg.test(value)) {
			// 		callback(new Error('邮箱格式有误'));
			// 	} else {
			// 		callback()
			// 	}
			// }
			return {
				type: '',
				jobLevel,
				time: 60,
				timer: null,
				isSend: false,
				checked: false,
				loading: false,
				step: 1,
				universityLoading: false,
				projectLoading: false,
				universityOptions: [],
				projectOptions: [],
				ruleForm: {
					name: '',
					email: '',
					phone: '',
					password: '',
					checkPass: '',
					school_id: ''
				},
				schoolForm: {
					name: '',
					mobile: '',
					email: '',
					password: '',
					checkPass: '',
					school_id: '',
					files: [],
				},
				schoolRules: {
					username: [{
						required: true,
						message: '请输入用户名',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						validator: schoolValidatePass,
						trigger: 'blur'
					}],
					checkPass: [{
						required: true,
						validator: schoolValidatePass2,
						trigger: 'blur'
					}],
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					school_id: [{
						required: true,
						message: '请选择所属高校/学院',
						trigger: 'change'
					}],
					project_ids: [{
						required: true,
						message: '请选择所属项目',
						trigger: 'change'
					}],
					department: [{
						required: true,
						message: '请输入部门',
						trigger: 'blur'
					}],
					mobile: [{
						required: true,
						validator: validatePhone,
						trigger: 'blur'
					}],
					email: [{
						required: true,
						validator: validateEmail,
						trigger: 'blur'
					}],
					files: [{
						required: true,
						validator: validateFiles,
						trigger: 'change'
					}],
				},
				rules: {
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					nickname: [{
						required: true,
						message: '请输入用户名',
						trigger: 'blur'
					}],
					level: [{
						required: true,
						message: '请选择职称',
						trigger: 'change'
					}],
					school_id: [{
						required: true,
						message: '请选择所属高校/学院',
						trigger: 'change'
					}],
					// id_card: [{
					// 	required: true,
					// 	validator: validateIdCard,
					// 	trigger: 'blur'
					// }],
					email: [{
						required: true,
						validator: validateEmail,
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						validator: validatePhone,
						trigger: 'blur'
					}],
					verify_code: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						validator: validatePass,
						trigger: 'blur'
					}],
					checkPass: [{
						required: true,
						validator: validatePass2,
						trigger: 'blur'
					}],
				}
			}
		},
		created() {
			this.projectMethod()
			let code = sessionStorage.getItem('vcode')
			if (code && Number(code) > 0) {
				this.time = code
				this.setTime()
			}
		},
		mounted() {
			this.type = this.$route.query.type || ''
			console.log(this.p_templates, 'p_templatesp_templates')
		},
		beforeDestroy() {

		},
		methods: {
			submitForm(formName) {
				let name = 'ruleForm',
					name2 = 'ruleForm2';
				if (this.type === 'school') {
					name = 'schoolRuleForm';
					name2 = 'schoolRuleForm2'
				}
				if (this.step == 1) {
					this.$refs[name].validate((valid) => {
						if (valid) {
							this.step = 2
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				} else {
					this.$refs[name2].validate((valid) => {
						console.log(222)
						if (valid) {
							if (this.type === 'school') {
								this.schoolRegisterUser()
							} else {
								this.registerUser()
							}
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				}

			},
			async registerUser() {
				this.loading = true
				try {
					const {
						data
					} = await register(this.ruleForm)
					this.loading = false
					console.log(data, '注册信息')
					this.$message.success('注册成功！请使用手机号登录！');
					// if(data){
					// 	this.$alert(`<strong>所属学校：${data.school_name}<br>管理员姓名：${data.name}<br>管理员手机号：<span style="color:#4979ff">${data.mobile}<span></strong>`, '注册完成，请耐心等待校级管理员审核！', {
					// 		dangerouslyUseHTMLString: true
					// 	});
					// }
					
					setTimeout(() => {
						this.$router.push('/')
					}, 1000)
				} catch (e) {
					this.loading = false
					// this.$message.error(JSON.stringify(e));
				}
			},
			async schoolRegisterUser() {
				this.loading = true
				try {
					const {
						data
					} = await schoolRegister(this.schoolForm)
					this.loading = false
					this.$message.success('注册成功！请耐心等待管理员审核！');
					setTimeout(() => {
						this.$router.push('/')
					}, 1000)
				} catch (e) {
					this.loading = false
					// this.$message.error(JSON.stringify(e));
				}
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			backLogin() {
				this.$router.push('/')
			},
			setTime() {
				this.isSend = true
				this.timer = setInterval(() => {
					this.time--
					sessionStorage.setItem('vcode', this.time)
					if (this.time <= 0) {
						setTimeout(() => {
							this.isSend = false
							this.time = 60
							clearInterval(this.timer)
						}, 1000)
					}
				}, 1000)
			},
			send() {
				this.$refs.ruleForm2.validateField('email', (errorMessage) => {
					console.log(errorMessage)
					if (!errorMessage) {
						this.sendCode()
						this.setTime()
					} else {
						console.log('error submit!!');
						return false;
					}
				})
			},
			// 发送验证码
			async sendCode() {
				try {
					const {
						data
					} = await sendCode({
						email: this.ruleForm.email
					})
					this.$message.success('您的验证码已发送，请注意接收');
				} catch (e) {
					this.$message.error(JSON.stringify(e));
				}
			},
			// 查询高校
			async remoteMethod(query) {
				if (query !== '') {
					this.universityLoading = true;
					const {
						data
					} = await getUniversityList({
						key_words: query,
						per_page: 20
					})
					this.universityOptions = data.data
					this.universityLoading = false
					console.log(this.universityOptions, 1111111111)
				}
			},
			// 查询所属项目
			async projectMethod(query) {
				this.projectLoading = true;
				const {
					data
				} = await queryProject({
					key_words: query,
					per_page: 20
				})
				this.projectOptions = data
				this.projectLoading = false
			},
			// 附件上传
			uploadSuccess(files) {
				console.log(files, 'filesfilesfilesfiles')
				this.schoolForm.files = files
			},
			// 下载模板
			handleTemplateDownload() {
				if (this.p_templates && this.p_templates.files.length) {
					window.open(this.p_templates.files[0].link_url)
				} else {
					this.$message.error('暂无可下载模板');
				}
			}
		}

	}
</script>

<style lang="scss" scoped>
	.login-container.school {
		// .left {
		// 	width: 42.5rem;
		// 	// background-color: #DFE7EE;
		// 	img{
		// 		height: 100%;
		// 	}
		// }

		// .right {
		// 	padding: 2.5rem;

		// 	.head {
		// 		padding-top: 0;
		// 	}
		// }
	}

	.downloadFile {
		cursor: pointer;
		color: #358BF6;
		flex-shrink: 0;
	}

	.downloadFile:hover {
		text-decoration: underline;
	}

	.login-container {
		border-radius: 0.625rem;
		overflow: hidden;
		box-shadow: 2px 4px 10px 4px rgba(92, 140, 199, .2);

		.left {
			width: 37.6rem;
			margin-right: -1px;

			// height: 43.75rem;
			img {
				width: 100%;
				margin-top: -4px;
			}
		}

		.right {
			flex-grow: 1;
			width: 0;
			background-color: white;
			padding: 2.5rem 7rem;

			.head {
				font-size: 1.35rem;
				font-weight: bold;
				position: relative;
				padding-top: 1.875rem;
				padding-left: 3rem;
				padding-right: 3rem;
				margin: 0 auto;
				color: #378DF7;
			}

			.head::after {
				content: "";
				display: block;
				width: 1.0416rem;
				height: 1.0416rem;
				position: absolute;
				left: .5rem;
				background: url(../../assets/login/left.png);
				bottom: .3rem;
			}

			.head::before {
				content: "";
				display: block;
				width: 1.0416rem;
				height: 1.0416rem;
				position: absolute;
				right: .5rem;
				background: url(../../assets/login/right.png);
				bottom: .3rem;
			}


			.flex-se {
				display: flex;
				align-items: flex-end;
				justify-content: space-between;
			}

			.return-login {
				font-size: 1rem;
				color: #4389E0;
				text-align: center;
				padding-top: 1.8rem;
			}

			.return-login.school {
				display: none;
			}

			.return-login:hover {
				cursor: pointer;
				text-decoration: underline;
			}

			.content {
				padding: 3rem 0 0;

				::v-deep .el-form-item {
					padding-bottom: 12px;
				}

				::v-deep .el-form-item__label {
					font-size: 1rem;
					font-weight: bold;
					padding-bottom: 0;
				}

				::v-deep .el-form-item__error {
					font-size: 1rem;
					padding-top: 9px;
				}

				::v-deep .el-input__inner {
					height: 3rem;
					font-size: 1rem;
				}

				::v-deep .el-input-group__prepend {
					background: none;
					border-right: 0 none;
					font-size: 1rem;
					color: #333;
				}

				.pc {
					display: flex;
				}

				.mobel {
					display: none;
				}

				.emphasize {
					color: red;
					padding-top: .6rem;
					padding-right: .4rem;
				}

				.prepend-selected {
					width: 100%;

					.prepend-selected-left {
						position: relative;
						border: 1px solid #DCDFE6;
						padding: 0 20px;
						white-space: nowrap;
						border-right: 0 none;
						height: 46px;
						line-height: 46px;
						font-size: 1rem;
						color: #333;
						border-radius: 4px 0 0 4px;
					}

					::v-deep .el-select {
						.el-input__inner {
							border-radius: 0 4px 4px 0;
						}
					}
				}

				.remember {
					font-size: 0.875rem;

					.forget {
						cursor: pointer;
						color: #4389E0;
					}

					.forget:hover {
						text-decoration: underline;
					}
				}

				.verify-code {
					width: 20rem;
				}

				.input-content {
					margin-bottom: 2rem;

					.input-prefix {
						position: relative;
						height: 100%;
						padding: 0 1.25rem;

						.input-icon {
							width: 1.125rem;
						}
					}

					.input-prefix::after {
						position: absolute;
						content: "";
						right: 0;
						height: 1.5rem;
						margin-top: -0.75rem;
						top: 50%;
						display: block;
						width: 1px;
						background-color: #DDDEE2;
					}
				}
			}

			.floor {
				width: 100%;

				::v-deep .el-button {
					width: 100%;
					height: 3.5rem;
					background: #358BF6;
					box-shadow: 1px 0.375rem 1.875rem 0px rgba(0, 114, 255, 0.3);
					border-radius: 0.25rem;
					color: white;
					font-size: 1rem;
				}
			}

			.register {
				padding-top: 1.875rem;
				color: #949BB0;

				.link {
					color: #4389E0;
					cursor: pointer;
				}

				.link:hover {
					text-decoration: underline;
				}
			}
		}

		.return-school {
			font-size: 1rem;
			color: #4389E0;
			text-align: center;
			padding-top: 5px;
		}

		.return-school:hover {
			cursor: pointer;
			text-decoration: underline;
		}
	}

	// 响应式

	@media screen and (min-width: 1200px) {}

	@media screen and (min-width: 923px) and (max-width:1199px) {}

	@media screen and (min-width: 768px) and (max-width:922px) {}

	@media screen and (max-width: 922px) {
		.login-container.school {
			.right {
				padding: 1rem 1.25rem;

				.head {
					padding-top: 2rem;
				}
			}
		}

		.login-container {
			box-shadow: 2px 4px 10px 4px rgba(92, 140, 199, 0);

			.left {
				display: none;
			}

			.right {
				padding: 1rem 1.25rem;

				.content {
					padding-top: 2.5rem;

					.pc {
						display: none;
					}

					.mobel {
						display: flex;
					}

					.verify-code {
						width: 11rem;
					}
				}

				.return-login.school {
					display: block;
				}
			}
		}

		.return-school {
			display: none;
		}
	}
</style>